<fa-icon [icon]="faIcon" [attr.class]="cssClass" aria-hidden="true" (click)="onButtonClick()"></fa-icon>
